/* Turakhia Eyewear - filter drawer redesign interactions.
   - <facet-list>: search-as-you-type + "Show N more" for long checkbox lists.
   - [data-price-presets]: radio price ranges that drive the min/max price inputs.
   Loaded once globally; guards against re-definition. Works after AJAX re-renders
   because custom elements re-upgrade and the price handler is delegated on document. */
(function () {
  if (!window.customElements || customElements.get('facet-list')) { /* still (re)bind price below */ }

  /* ---------- <facet-list> : search + show more ---------- */
  if (window.customElements && !customElements.get('facet-list')) {
    class FacetList extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('.facet-list__item'));
        this.search = this.querySelector('[data-facet-search]');
        this.more = this.querySelector('[data-facet-more]');
        this.expanded = false;

        if (this.more && !this.more.dataset.wired) {
          this.more.dataset.wired = '1';
          this.more.addEventListener('click', () => this.toggleMore());
        }
        if (this.search && !this.search.dataset.wired) {
          this.search.dataset.wired = '1';
          // keep the filter form from reacting to this (unnamed) input
          ['input', 'change', 'keyup'].forEach((t) =>
            this.search.addEventListener(t, (e) => { e.stopPropagation(); if (t === 'input') this.applySearch(); }));
          this.search.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); } });
        }
      }

      toggleMore() {
        this.expanded = !this.expanded;
        this.render();
        if (this.more) {
          this.more.setAttribute('aria-expanded', this.expanded ? 'true' : 'false');
          this.more.textContent = this.expanded ? (this.more.dataset.lessLabel || 'Show less') : (this.more.dataset.moreLabel || 'Show more');
        }
      }

      applySearch() {
        const q = (this.search.value || '').trim().toLowerCase();
        if (q) {
          this.items.forEach((li) => { li.hidden = li.dataset.label.indexOf(q) === -1; });
          if (this.more) this.more.hidden = true;
        } else {
          this.render();
          if (this.more) this.more.hidden = false;
        }
      }

      render() {
        this.items.forEach((li) => {
          if (li.hasAttribute('data-extra')) li.hidden = !this.expanded;
          else li.hidden = false;
        });
      }
    }
    customElements.define('facet-list', FacetList);
  }

  /* ---------- price range presets ---------- */
  function setInput(input, val) {
    if (!input) return;
    input.value = val;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
  if (!document.__ct_price_presets_bound) {
    document.__ct_price_presets_bound = true;
    document.addEventListener('change', function (e) {
      const radio = e.target.closest('[data-price-presets] input[type="radio"]');
      if (!radio) return;
      const wrap = radio.closest('[data-price-presets]');
      const min = document.getElementById(wrap.dataset.minInput);
      const max = document.getElementById(wrap.dataset.maxInput);
      setInput(min, radio.dataset.min || '');
      setInput(max, radio.dataset.max || '');
    });
  }
})();
